import { Subject } from "rxjs";

// dialog subjects
export const openModal = new Subject();
export const closeModal = new Subject();

export const loader = new Subject();
